module.exports = __webpack_public_path__ + "media/application/images/n-a-3aa687fe7e334f4f6282e166e07760c1.jpg";